import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Input,
  InputAdornment,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Chip,
  IconButton,
  Autocomplete,
  TextField,
} from "@mui/material";
import { useSelector } from "react-redux";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import { useFormik } from "formik";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { GET_ALL_CUSTOMER_FILTER_URL } from "../../constants/ApiRoute";
import API from "../comman/API";
import { authHeader } from "../comman/MainFunction";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const modelFilterInitial = {
  active: "",
  customerActive: "",
  noOfLocation: "",
  noOfBroker: "",
  billingPeriod: "",
  projectId: "",
  customerId: "",
};

export default function ProjectFilter(props) {
  const {
    open,
    handleClose,
    filter,
    setFilter,
    filterInitial,
    customerNameList,
    // applyFilterFun,
    submitFilter,
  } = props;

  console.log("props filter", filter);

  const [customerName, setCustomer] = React.useState([]);
  const list = deCryptFun(useSelector((s) => s.AllCustomerListReducer));
  const [customerActivel, setCustomerActive] = useState(true);
  const [projectActive, setProjectActive] = useState("");
  const [cusList, setList] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [modelFilter, setModelFilter] = useState(modelFilterInitial);

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const submitFilterFilter = () => {
    setFilter((prevState) => ({
      ...prevState,
      active: modelFilter.active,
      customerActive: modelFilter.customerActive,
      noOfLocation: modelFilter.noOfLocation,
      noOfBroker: modelFilter.noOfBroker,
      billingPeriod: modelFilter.billingPeriod,
      projectId: modelFilter.projectId,
      customerId: modelFilter.customerId,
    }));
    setIsFormSubmitted(true);
  };

  useEffect(() => {
    if (isFormSubmitted) {
      submitFilter();
    }
  }, [isFormSubmitted]);

  useEffect(() => {
    setModelFilter(filter);
    if (filter.customerId.length > 0) {
      selectedCustomerLoad(filter);
    }
  }, []);

  const selectedCustomerLoad = async (filter) => {
    var filterValue = "";
    if (filter.customerActive === true) {
      filterValue = filter.customerActive;
    } else if (filter.customerActive === false) {
      filterValue = filter.customerActive;
    } else {
      filterValue == "";
    }

    let data = {
      count: 1000,
      offset: 0,
    };

    if (filterValue != "") {
      data.active = filterValue;
    }

    const config = {
      method: "GET",
      url: GET_ALL_CUSTOMER_FILTER_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        let cusList = parsedResponse.data;

        const filteredData = cusList.filter((item) =>
          filter.customerId.includes(item.UserId)
        );
        setSelectedCustomer(filteredData);
      } else {
        setSelectedCustomer([]);
      }
    } catch (error) {
      setSelectedCustomer([]);
    }
  };

  const handleChangeCustomerStatus = (status) => {
    console.log(status, "status-Active");
    let st = "";
    if (status === "Active") {
      st = true;
    } else if (status === "Inactive") {
      st = false;
    } else {
      st = "";
    }
    setModelFilter({ ...modelFilter, customerActive: st, customerId: [] });

    handleChangeOnLoadSelectedCustomer([]);

    // setFilter({ ...filter, customerActive: st, customerId: [] });
  };
  const handleChangeProjectStatus = (status) => {
    let st = "";
    if (status === "Active") {
      st = true;
    } else if (status === "Inactive") {
      st = false;
    }
    setModelFilter({ ...modelFilter, active: st });
    // setFilter({ ...filter, active: st });
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const resetFun = () => {
    // setFilter(filterInitial);
    setModelFilter(modelFilterInitial);
    handleChangeOnLoadSelectedCustomer([]);
    setCustomer([]);
    setCustomerActive("");
    setProjectActive("");
  };
  //Filter Onchange Function

  const handleChangebill = (e) => {
    //setBillingDefaultPeriod(e.target.value)
    const { name, value } = e.target;
    const intValue = value.replace(/[^\d]/g, "");
    const sanitizedValue =
      intValue === "" ? "" : Math.min(parseInt(intValue), 31).toString();

    setModelFilter({ ...modelFilter, billingPeriod: sanitizedValue });
    //setFilter({ ...filter, billingPeriod: sanitizedValue });
  };
  const handleChangeLoc = (e) => {
    const { name, value } = e.target;
    const intValue = value.replace(/[^\d]/g, "");
    const sanitizedValue = intValue === "" ? "" : parseInt(intValue).toString();

    setModelFilter({ ...modelFilter, noOfLocation: sanitizedValue });
    //setFilter({ ...filter, noOfLocation: sanitizedValue });
  };
  const handleChangeBroker = (e) => {
    const { name, value } = e.target;
    const intValue = value.replace(/[^\d]/g, "");
    const sanitizedValue = intValue === "" ? "" : parseInt(intValue).toString();

    setModelFilter({ ...modelFilter, noOfBroker: sanitizedValue });
    //setFilter({ ...filter, noOfBroker: sanitizedValue });
  };

  const getSelectedCustomerList = async () => {
    var filterValue = "";
    if (modelFilter.customerActive === true) {
      filterValue = modelFilter.customerActive;
    } else if (modelFilter.customerActive === false) {
      filterValue = modelFilter.customerActive;
    } else {
      filterValue = ""; // Correct the assignment operator here (was `==`)
    }

    let data = {
      count: 1000,
      offset: 0,
    };

    console.log(filterValue, "valyeeeeeeeeee");

    // Only add the active property if filterValue is not empty
    if (filterValue === true || filterValue === false) {
      data.active = filterValue;
    }

    const config = {
      method: "GET",
      url: GET_ALL_CUSTOMER_FILTER_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        setList(parsedResponse.data);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        //       showToast(v.message, "error");
      }
    }
  };
  useEffect(() => {
    getSelectedCustomerList();
  }, [modelFilter.customerActive]);

  const handleSearchCheckboxOnChange = (value, isSelected) => {
    if (isSelected) {
      var arr = selectedCustomer.filter((item) => item.UserId !== value.UserId);
      let selectedCustomerIds = arr.map((customerVal) => customerVal.UserId);
      setModelFilter({ ...modelFilter, customerId: selectedCustomerIds });
      //setFilter({ ...filter, customerId: selectedCustomerIds });
      handleChangeOnLoadSelectedCustomer(selectedCustomerIds);
    } else {
      const updatedProjects = [...selectedCustomer, value];
      let selectedCustomerIds = updatedProjects.map(
        (customerVal) => customerVal.UserId
      );
      setModelFilter({ ...modelFilter, customerId: selectedCustomerIds });
      //setFilter({ ...filter, customerId: selectedCustomerIds });
      handleChangeOnLoadSelectedCustomer(selectedCustomerIds);
    }
  };

  const handleChangeOnLoadSelectedCustomer = (selectedCustomerIds) => {
    if (selectedCustomerIds.length > 0) {
      const filteredData = cusList.filter((item) =>
        selectedCustomerIds.includes(item.UserId)
      );
      setSelectedCustomer(filteredData);
    } else if (selectedCustomerIds.length == 0) {
      setSelectedCustomer([]);
    }
  };

  // useEffect(() => {
  //   if (
  //     modelFilter.customerId &&
  //     modelFilter.customerId.length > 0 &&
  //     cusList.length > 0
  //   ) {
  //     const filteredData = cusList.filter((item) =>
  //       modelFilter.customerId.includes(item.UserId)
  //     );
  //     setSelectedCustomer(filteredData);
  //   } else if (modelFilter.customerId.length == 0) {
  //     setSelectedCustomer([]);
  //   }
  // }, [modelFilter.customerId, cusList]);

  const handleSearchOnChange = (event, newValue) => {
    const duplicateArray = findDuplicateProjectId(newValue);
    if (duplicateArray && duplicateArray.length > 0) {
      const updatedNewArray = newValue.filter(
        (obj) => obj.UserId !== duplicateArray[0]
      );
      newValue = updatedNewArray;
    }
    const uniqueSelectedProjects = newValue.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.UserId === item.UserId)
    );
    let selectedCustomerIds = uniqueSelectedProjects.map(
      (customerVal) => customerVal.UserId
    );
    setModelFilter({ ...modelFilter, customerId: selectedCustomerIds });
    handleChangeOnLoadSelectedCustomer(selectedCustomerIds);
    //setFilter({ ...filter, customerId: selectedCustomerIds });
  };

  const findDuplicateProjectId = (array) => {
    let seen = new Set();
    let duplicates = new Set();

    array.forEach((obj) => {
      if (seen.has(obj.UserId)) {
        duplicates.add(obj.UserId);
      } else {
        seen.add(obj.UserId);
      }
    });

    return Array.from(duplicates);
  };

  const handleSearchDeleteOnChange = (value) => {
    var arr = selectedCustomer.filter((item) => item.UserId !== value);
    let selectedCustomerIds = arr.map((customerVal) => customerVal.UserId);
    setModelFilter({ ...modelFilter, customerId: selectedCustomerIds });
    handleChangeOnLoadSelectedCustomer(selectedCustomerIds);
    // setFilter({ ...filter, customerId: selectedCustomerIds });
  };

  return (
    <>
      <Dialog
        className="user-filter-popup project-filter-prop"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        component={"form"}
      >
        <Stack
          sx={{ p: "25px 34px" }}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography className="model-title">Filter Properties</Typography>
          <Button
            className="edit-btn"
            variant="outlined"
            startIcon={<span class="material-symbols-outlined">history</span>}
            onClick={resetFun}
          >
            Reset Filter
          </Button>
        </Stack>
        <Box sx={{ p: "0px 34px 0px 34px" }}>
          <Stack
            sx={{ p: { xs: "0px 0px 0px 0px", md: "0px 1px 0px 0px" } }}
            direction={{ xs: "column", sm: "row", md: "row" }}
            alignItems={{ xs: "end", md: "center" }}
            justifyContent="space-between"
            spacing={2}
          >
            <Box
              className="project-prop-check"
              sx={{ width: "100%", minWidth: "265px" }}
            >
              <p style={{ marginBottom: "0px" }} className="label">
                Customer Status:
              </p>

              <FormControlLabel
                sx={{ ml: "-2px" }}
                className="checkbox"
                control={
                  <Checkbox
                    name="customerActiveAll"
                    id="customerActiveAll"
                    onChange={() => handleChangeCustomerStatus("All")}
                    checked={modelFilter.customerActive === ""}
                    sx={{ color: "gray", pl: "0px" }}
                  />
                }
                label="All"
              />
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    name="customerActive"
                    id="customerActive"
                    onChange={() => handleChangeCustomerStatus("Active")}
                    checked={modelFilter.customerActive === true}
                    sx={{ color: "gray" }}
                  />
                }
                label="Active"
              />
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    name="customerActiveIn"
                    id="customerActiveIn"
                    onChange={() => handleChangeCustomerStatus("Inactive")}
                    checked={modelFilter.customerActive === false}
                    sx={{ color: "gray" }}
                  />
                }
                label="Inactive"
              />
            </Box>

            <Box
              className="project-prop-check"
              sx={{ width: "100%", minWidth: "265px", ml: "47px !important" }}
            >
              <p style={{ marginBottom: "0px" }} className="label">
                Project Status:
              </p>
              <FormControlLabel
                sx={{ ml: "-2px" }}
                className="checkbox"
                control={
                  <Checkbox
                    name="customerActiveAll"
                    id="customerActiveAll"
                    onChange={() => handleChangeProjectStatus("All")}
                    checked={modelFilter.active === ""}
                    sx={{ color: "gray", pl: "0px" }}
                  />
                }
                label="All"
              />
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    name="projectActive"
                    id="projectActive"
                    onChange={() => handleChangeProjectStatus("Active")}
                    checked={modelFilter.active === true}
                    sx={{ color: "gray" }}
                  />
                }
                label="Active"
              />
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    name="projectActiveIn"
                    id="projectActiveIn"
                    onChange={() => handleChangeProjectStatus("Inactive")}
                    checked={modelFilter.active === false}
                    sx={{ color: "gray" }}
                  />
                }
                label="Inactive"
              />
            </Box>
          </Stack>
          <Box>
            <FormControl
              className="search-box filter-prop-search"
              sx={{ m: 1, minWidth: "350px", ml: "0px" }}
            >
              <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                options={cusList}
                disableCloseOnSelect
                limitTags={1}
                popupIcon={<KeyboardArrowDownIcon />}
                getOptionLabel={(option) => option.Name}
                filterOptions={(options, { inputValue }) => {
                  const normalizedInput = inputValue.trim().toLowerCase();
                
                  if (!normalizedInput) {
                    // Sort all options if input is empty
                    return options.sort((a, b) => a.Name.localeCompare(b.Name));
                  }
                
                  // Filter and sort matching options
                  return options
                    .filter(option =>
                      option.Name.toLowerCase().includes(normalizedInput)
                    )
                    .sort((a, b) => a.Name.localeCompare(b.Name));
                }}
                onChange={handleSearchOnChange}
                value={selectedCustomer}
                renderTags={() => null}
                renderOption={(props, option, { selected }) => {
                  const isSelected = selectedCustomer.some(
                    (customer) => customer.UserId === option.UserId
                  );

                  return (
                    <li {...props} key={option.UserId}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={isSelected}
                        onChange={() =>
                          handleSearchCheckboxOnChange(option, isSelected)
                        }
                      />
                      <span className="select-option-text">{option.Name}</span>
                    </li>
                  );
                }}
                style={{ width: 350, height: 40 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Search Customers"
                  />
                )}
              />
            </FormControl>

            <div style={{ marginTop: 5, width: "100%" }}>
              {selectedCustomer.map((option) => (
                <Chip
                  key={option.UserId}
                  label={option.Name}
                  onDelete={() => {
                    handleSearchDeleteOnChange(option.UserId);
                  }}
                  style={{ margin: 5 }}
                />
              ))}
            </div>
          </Box>
          {/* <Stack
            sx={{ mt: "15px" }}
            direction="row"
            alignItems="center"
            spacing={2}
          >
            <FormControl className="search-box" sx={{ m: 1, width: 265 }}>
              <Select
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                multiple
                value={customerName}
                onChange={handleChangeCustomer}
                input={<OutlinedInput id="select-multiple-chip" />}
                renderValue={(selected) => (
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {selected.map((customerId) => {
                      {
                        console.log("ids", customerId);
                      }
                      const customer = JSON.parse(list).data.find(
                        (c) => parseInt(c.UserId) === parseInt(customerId)
                      );
                      {
                        console.log("given", customer);
                      }
                      return (
                        <Chip
                          key={customerId}
                          label={customer ? customer.Name : "Unknown"}
                        />
                      );
                    })}
                  </div>
                )}
                MenuProps={MenuProps}
                startAdornment={
                  <InputAdornment position="start">
                    <span class="material-symbols-outlined">search</span>
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="start">
                    {customerName && customerName.length > 0 ? (
                      <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={clearProject}
                      >
                        <HighlightOffIcon fontSize="small" />
                      </IconButton>
                    ) : (
                      ""
                    )}
                  </InputAdornment>
                }
              >
                {/* <MenuItem disabled value="">
                      <em>Select User</em>
                    </MenuItem> */}
          {/* {cusList &&
                  cusList.map((value) => (
                    <MenuItem key={value.UserId} value={value.UserId}>
                      <Checkbox
                        checked={customerName.indexOf(value.UserId) > -1}
                      />
                      <ListItemText primary={value.Name} />
                    </MenuItem>
                  ))}
              </Select>
            </FormControl> */}
          {/* </Stack> */}

          <Stack
            sx={{ mt: "15px" }}
            direction="row"
            alignItems="center"
            spacing={4.2}
          >
            <FormControl sx={{ width: "100%" }} variant="standard">
              <p className="label">Billing Period (in days):</p>
              <Input
                name="billingPeriod"
                id="billingPeriod"
                value={modelFilter.billingPeriod}
                onChange={handleChangebill}
                placeholder="Enter Billing Period"
              />
            </FormControl>
            <FormControl sx={{ width: "100%" }} variant="standard">
              <p className="label">No of location:</p>
              <Input
                name="noOfLocation"
                id="noOfLocation"
                value={modelFilter.noOfLocation}
                onChange={handleChangeLoc}
                // disabled={editFlag}
                placeholder="Enter No of Locations"
              />
            </FormControl>
          </Stack>
          <Stack
            sx={{ mt: "20px" }}
            direction="row"
            alignItems="center"
            spacing={4.2}
          >
            <FormControl
              sx={{ width: { xs: "100%", md: "48%" } }}
              variant="standard"
            >
              <p className="label">No of Brokers:</p>
              <Input
                name="noOfBroker"
                id="noOfBroker"
                value={modelFilter.noOfBroker}
                onChange={handleChangeBroker}
                // disabled={editFlag}
                placeholder="Enter No of Brokers"
              />
            </FormControl>
          </Stack>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 34px", pt: "24px" }}
        >
          <Button className="filter-btn" onClick={submitFilterFilter}>
            Apply Filter
          </Button>
          <Button className="cancel-btn" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
